import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/redux/useApp';
import {
  closeEventForReviewThunk,
  fetchAccountClusterThunk,
  openEventForReviewThunk,
} from '../store/contentModerationThunks';
import {
  selectClusterData,
  selectDetailData,
  selectDetailError,
  selectDetailLoading,
  selectLockState,
} from '../store/contentModerationSelectors';

export interface UseEventDetailResult {
  detail: ReturnType<typeof selectDetailData>;
  cluster: ReturnType<typeof selectClusterData>;
  isLoading: boolean;
  error: ReturnType<typeof selectDetailError>;
  lockState: ReturnType<typeof selectLockState>;
}

export function useEventDetail(id: number | null): UseEventDetailResult {
  const dispatch = useAppDispatch();
  const detail = useAppSelector(selectDetailData);
  const cluster = useAppSelector(selectClusterData);
  const isLoading = useAppSelector(selectDetailLoading);
  const error = useAppSelector(selectDetailError);
  const lockState = useAppSelector(selectLockState);

  useEffect(() => {
    if (id == null) return undefined;
    void dispatch(openEventForReviewThunk(id));
    return () => {
      void dispatch(closeEventForReviewThunk(id));
    };
  }, [id, dispatch]);

  const accountId = detail?.event?.linkedAccountId ?? null;
  useEffect(() => {
    if (accountId == null) return;
    void dispatch(fetchAccountClusterThunk(accountId));
  }, [accountId, dispatch]);

  return { detail, cluster, isLoading, error, lockState };
}
